import React, { useState } from "react";
import { Plus, X, Send } from "lucide-react";
import { INK, INK_2, LINE, BG, BURGUNDY } from "../bureauTokens";

const TYPES = ["KPI chiffré", "Liste / rappel", "Raccourci", "Autre"];

function TypeChip({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className="transition-colors"
      style={{
        border: `1px solid ${active ? BURGUNDY : LINE}`,
        background: active ? BURGUNDY : "#fff",
        color: active ? "#fff" : INK_2,
        borderRadius: 999,
        padding: "7px 14px",
        fontSize: 11,
        fontWeight: 500,
      }}
    >
      {label}
    </button>
  );
}

function SuggestModal({ profileLabel, onClose, onSubmit }) {
  const [idea, setIdea] = useState("");
  const [type, setType] = useState(TYPES[0]);
  const [sending, setSending] = useState(false);
  const [focused, setFocused] = useState(false);

  const submit = async () => {
    if (!idea.trim() || sending) return;
    setSending(true);
    try {
      await onSubmit({ type, idea: idea.trim() });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40" onClick={onClose}>
      <div
        className="w-[420px] mx-4 overflow-hidden"
        style={{ background: "#fff", borderRadius: 16, boxShadow: "0 24px 60px rgba(20,14,24,.30)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="flex items-center justify-between px-5 py-4"
          style={{ background: BURGUNDY, color: "#fff" }}
        >
          <div className="flex items-center gap-2.5 text-sm font-semibold">
            <Plus size={16} /> Suggérer une idée de tuile
          </div>
          <button onClick={onClose} className="opacity-80 hover:opacity-100">
            <X size={16} />
          </button>
        </div>
        <div className="px-5 py-4 space-y-4">
          <p className="text-xs leading-relaxed" style={{ color: INK_2 }}>
            Proposez l'indicateur ou le raccourci que vous aimeriez voir dans votre Bureau «{" "}
            {profileLabel} ». Votre suggestion sera envoyée par email à l'administrateur MyALFA.
          </p>
          <div>
            <label className="block text-xs font-semibold mb-2" style={{ color: INK_2 }}>
              Type de tuile souhaitée
            </label>
            <div className="flex flex-wrap gap-2">
              {TYPES.map((t) => (
                <TypeChip key={t} label={t} active={type === t} onClick={() => setType(t)} />
              ))}
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold mb-2" style={{ color: INK_2 }}>
              Que souhaiteriez-vous suivre ici ?
            </label>
            <textarea
              value={idea}
              onChange={(e) => setIdea(e.target.value)}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              placeholder="Ex. Nombre de dossiers en attente de pièces, échéances IR à venir…"
              className="w-full h-24 px-3.5 py-2.5 text-xs outline-none resize-none transition-colors"
              style={{
                border: `1px solid ${focused ? BURGUNDY : LINE}`,
                borderRadius: 10,
                color: INK,
                boxShadow: focused ? "0 0 0 3px rgba(110,26,54,.10)" : "none",
              }}
            />
          </div>
        </div>
        <div
          className="flex items-center justify-end gap-2.5 px-5 py-3.5"
          style={{ borderTop: `1px solid ${LINE}`, background: BG }}
        >
          <button
            onClick={onClose}
            className="px-4 py-2 text-xs transition-colors hover:bg-white"
            style={{ border: `1px solid ${LINE}`, borderRadius: 10, color: INK_2, background: "#fff" }}
          >
            Annuler
          </button>
          <button
            onClick={submit}
            disabled={!idea.trim() || sending}
            className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ background: BURGUNDY, color: "#fff", borderRadius: 10 }}
          >
            <Send size={14} /> {sending ? "Envoi…" : "Envoyer la suggestion"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuggestModal;
